export default {
    verb: 'doingCancel',
    namespace: 'transaction',
    relation: 'itemsByModel',
    description: 'collapse the "Create With Auto Serialization" detail pane when the form is canceled',
    logic: closePane
};

// The "Create With Auto Serialization" form renders in an item:item detail pane
// (showForAction: 'newAutoSerial') hosting a self-managing SingleRecordForm on the virtual
// transaction:itemsByModel relation. Canceling the inner form clears the *inner*
// (transaction) ActiveRecord — which just re-initializes the blank form — but leaves the
// *host* item:item ActiveRecord (which controls pane visibility) untouched, so the pane
// would stay open with a fresh blank form. Clear the host by dispatching a 'cancel item:item'
// (SummaryDetailLayout collapses when its record == null). This runs only after the generic
// willCancel confirmation has passed, so a declined "unsaved changes" prompt aborts the
// workflow before we get here. type 'ignore-changes' avoids a second confirmation on the
// host. We still return the standard cleared cancel payload so the inner form resets too.
function closePane({ context, dispatch, data }) {
    const { namespace, relation, type } = context;
    dispatch(
        {},
        {
            verb: 'cancel',
            namespace: 'item',
            relation: 'item',
            type: 'ignore-changes'
        }
    );
    // Propagate willCancel's decision rather than hard-coding true: willCancel sets
    // ignoreChanges only for a confirmed FormButton cancel; for any other cancel it stays
    // unset so ActiveRecord still shows its own unsaved-changes prompt. Mirrors the generic
    // doingCancel_namespace_relation.
    return { namespace, relation, type, ignoreChanges: data?.ignoreChanges };
}
